// Design tokens — Direction A (Black + Cyan)
// Sourced from design_handoff_xlerate_portal/README.md
// Use these for raw access from `sx` props and inline styles where the MUI
// palette doesn't carry the right semantic key.

export const tokens = {
  bg: "#f6f6f4",
  surface: "#ffffff",
  surfaceMuted: "#f1f1ee",
  border: "#e6e4dc",
  borderStrong: "#d4d1c5",

  ink: "#0a0a0a",
  inkMuted: "#3f3f3a",
  inkSoft: "#7c7a72",

  black: "#0a0a0a",
  blackDeep: "#000000",
  blackSoft: "#1c1c1c",

  gold: "#c9a14b",
  goldDeep: "#a8842f",
  goldSoft: "#f5ecd2",
  goldTint: "#faf3df",

  cyan: "#5dd8d2",
  cyanDeep: "#2eb5af",
  cyanSoft: "#dff7f5",

  danger: "#d23a2a",
  warning: "#c87a15",
  success: "#3f7a3a",
};

export const tokensDark = {
  bg: "#0a0a0a",
  surface: "#141414",
  surfaceMuted: "#1c1c1c",
  border: "#2a2a26",
  borderStrong: "#3a3a34",

  ink: "#f6f6f4",
  inkMuted: "#cfcdc4",
  inkSoft: "#8e8c84",

  black: "#0a0a0a",
  blackDeep: "#000000",
  blackSoft: "#1c1c1c",

  gold: "#c9a14b",
  goldDeep: "#d6b160",
  goldSoft: "#3a2f17",
  goldTint: "#2c2516",

  cyan: "#5dd8d2",
  cyanDeep: "#7be3de",
  cyanSoft: "#1c2c2b",

  danger: "#e8584a",
  warning: "#e09a3a",
  success: "#5fa057",
};

export const fonts = {
  sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", system-ui, sans-serif',
  serif: '"Fraunces", Georgia, "Times New Roman", serif',
  mono: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
};

export const radii = {
  card: 8,
  button: 6,
  pill: 4,
  input: 6,
};

export const layout = {
  sidebarWidth: 232,
  topBarHeight: 56,
  pagePadding: 28,
};

// Tone definitions for badges (priority / status / compliance / contacts).
// Lookup as: badgeTones[tone] || badgeTones.neutral
export const badgeTones = {
  neutral: { fg: "#3f3f3a", bg: "#f1f1ee", border: "#e6e4dc" },
  Urgent: { fg: "#a8261a", bg: "#fdebe7", border: "#f0c2bb" },
  High: { fg: "#a8261a", bg: "#fdebe7", border: "#f0c2bb" },
  Medium: { fg: "#9a5e10", bg: "#fbf0d6", border: "#ecd9a3" },
  Low: { fg: "#3f7a3a", bg: "#e9f1e7", border: "#cbdfc4" },
  Open: { fg: "#9a5e10", bg: "#fbf0d6", border: "#ecd9a3" },
  "In Progress": { fg: "#2eb5af", bg: "#dff7f5", border: "#b8e8e4" },
  Resolved: { fg: "#7c7a72", bg: "#f1f1ee", border: "#e6e4dc" },
  Closed: { fg: "#7c7a72", bg: "#f1f1ee", border: "#e6e4dc" },
  valid: { fg: "#3f7a3a", bg: "#e9f1e7", border: "#cbdfc4" },
  expiring: { fg: "#9a5e10", bg: "#fbf0d6", border: "#ecd9a3" },
  expired: { fg: "#a8261a", bg: "#fdebe7", border: "#f0c2bb" },
  complete: { fg: "#3f7a3a", bg: "#e9f1e7", border: "#cbdfc4" },
  missing: { fg: "#a8261a", bg: "#fdebe7", border: "#f0c2bb" },
};
